import React from 'react'
import styles from "./Profile.module.scss"
import { Form, useFormikContext } from 'formik'
import { FormControl, FormHelperText, InputLabel, MenuItem, Select, TextField } from '@mui/material'
import Button from 'components/shared/button/Button'
const Comments = [
    "Email",
    "Text Message",
    "Push Notification",
    "Email & Notification",
    "Do Not Notify"

]
const Annoucements = [
    "Push Notification",

]
const Alerts = [
    "Email",
    "Text Message",
    "Push Notification",
    "Email & Push Notification",
    "Do Not Notify"
]
const TaskDue = [
    "Email",
    "Do Not Notify"
]
const NotificationForm = () => {
    const formik = useFormikContext();
    return (
        <>

            <Form>
                <div className={styles?.form}>
                    <div className={styles?.formBody}>
                        <InputLabel sx={{ fontSize: "14px", fontWeight: 600 }}>
                            Communication
                        </InputLabel>
                        <FormControl size='small' variant="filled">
                            <InputLabel id="demo-simple-select-filled-label">Comments</InputLabel>

                            <Select
                                name={`comments`}
                                value={formik.values.comments}
                                onChange={(e) => {
                                    formik.setFieldValue(`comments`, e?.target?.value)
                                }}
                                error={
                                    formik.touched.comments && Boolean(formik.errors.comments)
                                }
                            >
                                {
                                    Comments?.map((comment) => {
                                        return <MenuItem value={comment}>{comment}</MenuItem>
                                    })
                                }


                            </Select>
                            {formik.touched.comments && formik.errors.comments ? (
                                <FormHelperText
                                    sx={{ color: "#bf3333", marginLeft: "0px" }}
                                >
                                    {formik.touched.comments && formik.errors.comments}
                                </FormHelperText>
                            ) : null}
                        </FormControl>
                        <FormControl size='small' variant="filled">
                            <InputLabel id="demo-simple-select-filled-label">Annoucements</InputLabel>

                            <Select
                                name={`annoucements`}
                                value={formik.values.annoucements}
                                onChange={(e) => {
                                    formik.setFieldValue(`annoucements`, e?.target?.value)
                                }}
                                error={
                                    formik.touched.annoucements && Boolean(formik.errors.annoucements)
                                }
                            >
                                {
                                    Annoucements?.map((annoucement) => {
                                        return <MenuItem value={annoucement}>{annoucement}</MenuItem>
                                    })
                                }
                            </Select>
                            {formik.touched.annoucements && formik.errors.annoucements ? (
                                <FormHelperText
                                    sx={{ color: "#bf3333", marginLeft: "0px" }}
                                >
                                    {formik.touched.annoucements && formik.errors.annoucements}
                                </FormHelperText>
                            ) : null}
                        </FormControl>
                        <InputLabel sx={{ fontSize: "14px", fontWeight: 600 }}>
                            Forms & Triggers
                        </InputLabel>

                        <FormControl size='small' variant="filled">
                            <InputLabel id="demo-simple-select-filled-label">Alerts</InputLabel>

                            <Select
                                name={`alerts`}
                                value={formik.values.alerts}
                                onChange={(e) => {
                                    formik.setFieldValue(`alerts`, e?.target?.value)
                                }}
                                error={
                                    formik.touched.alerts && Boolean(formik.errors.alerts)
                                }
                            >
                                {
                                    Alerts?.map((alert) => {
                                        return <MenuItem value={alert}>{alert}</MenuItem>
                                    })
                                }
                            </Select>
                            {formik.touched.alerts && formik.errors.alerts ? (
                                <FormHelperText
                                    sx={{ color: "#bf3333", marginLeft: "0px" }}
                                >
                                    {formik.touched.alerts && formik.errors.alerts}
                                </FormHelperText>
                            ) : null}
                        </FormControl>

                        <FormControl size='small' variant="filled">
                            <InputLabel id="demo-simple-select-filled-label">New Forms Available</InputLabel>

                            <Select
                                name={`forms`}
                                value={formik.values.forms}
                                onChange={(e) => {
                                    formik.setFieldValue(`forms`, e?.target?.value)
                                }}
                                error={
                                    formik.touched.forms && Boolean(formik.errors.forms)
                                }
                            >
                                {
                                    Alerts?.map((alert) => {
                                        return <MenuItem value={alert}>{alert}</MenuItem>
                                    })
                                }
                            </Select>
                            {formik.touched.forms && formik.errors.forms ? (
                                <FormHelperText
                                    sx={{ color: "#bf3333", marginLeft: "0px" }}
                                >
                                    {formik.touched.forms && formik.errors.forms}
                                </FormHelperText>
                            ) : null}
                        </FormControl>
                        <InputLabel sx={{ fontSize: "14px", fontWeight: 600 }}>
                            Tasks
                        </InputLabel>

                        <FormControl size='small' variant="filled">
                            <InputLabel id="demo-simple-select-filled-label">Task Assigned</InputLabel>

                            <Select
                                name={`taskAssigned`}
                                value={formik.values.taskAssigned}
                                onChange={(e) => {
                                    formik.setFieldValue(`taskAssigned`, e?.target?.value)
                                }}
                                error={
                                    formik.touched.taskAssigned && Boolean(formik.errors.taskAssigned)
                                }
                            >
                                {
                                    Alerts?.map((alert) => {
                                        return <MenuItem value={alert}>{alert}</MenuItem>
                                    })
                                }
                            </Select>
                            {formik.touched.taskAssigned && formik.errors.taskAssigned ? (
                                <FormHelperText
                                    sx={{ color: "#bf3333", marginLeft: "0px" }}
                                >
                                    {formik.touched.taskAssigned && formik.errors.taskAssigned}
                                </FormHelperText>
                            ) : null}
                        </FormControl>

                        <FormControl size='small' variant="filled">

                            <InputLabel id="demo-simple-select-filled-label">Task Completed</InputLabel>
                            <Select
                                name={`taskCompleted`}
                                value={formik.values.taskCompleted}
                                onChange={(e) => {
                                    formik.setFieldValue(`taskCompleted`, e?.target?.value)
                                }}
                                error={
                                    formik.touched.taskCompleted && Boolean(formik.errors.taskCompleted)
                                }
                            >

                                {
                                    Alerts?.map((alert) => {
                                        return <MenuItem value={alert}>{alert}</MenuItem>
                                    })
                                }
                            </Select>
                            {formik.touched.taskCompleted && formik.errors.taskCompleted ? (
                                <FormHelperText
                                    sx={{ color: "#bf3333", marginLeft: "0px" }}
                                >
                                    {formik.touched.taskCompleted && formik.errors.taskCompleted}
                                </FormHelperText>
                            ) : null}
                        </FormControl>

                        <FormControl size='small' variant="filled">
                            <InputLabel id="demo-simple-select-filled-label">Tasks due soon reminder</InputLabel>

                            <Select
                                name={`taskDue`}
                                value={formik.values.taskDue}
                                onChange={(e) => {
                                    formik.setFieldValue(`taskDue`, e?.target?.value)
                                }}
                                error={
                                    formik.touched.taskDue && Boolean(formik.errors.taskDue)
                                }
                            >
                                {
                                    TaskDue?.map((task) => {
                                        return <MenuItem value={task}>{task}</MenuItem>
                                    })
                                }
                            </Select>
                            {formik.touched.taskDue && formik.errors.taskDue ? (
                                <FormHelperText
                                    sx={{ color: "#bf3333", marginLeft: "0px" }}
                                >
                                    {formik.touched.taskDue && formik.errors.taskDue}
                                </FormHelperText>
                            ) : null}
                        </FormControl>
                        <FormControl size='small' variant="filled">
                            <InputLabel id="demo-simple-select-filled-label">Overdue tasks reminder</InputLabel>

                            <Select
                                name={`taskOverDue`}
                                value={formik.values.taskOverDue}
                                onChange={(e) => {
                                    formik.setFieldValue(`taskOverDue`, e?.target?.value)
                                }}
                                error={
                                    formik.touched.taskOverDue && Boolean(formik.errors.taskOverDue)
                                }
                            >
                                {
                                    TaskDue?.map((task) => {
                                        return <MenuItem value={task}>{task}</MenuItem>
                                    })
                                }
                            </Select>
                            {formik.touched.taskOverDue && formik.errors.taskOverDue ? (
                                <FormHelperText
                                    sx={{ color: "#bf3333", marginLeft: "0px" }}
                                >
                                    {formik.touched.taskOverDue && formik.errors.taskOverDue}
                                </FormHelperText>
                            ) : null}
                        </FormControl>



                        <div>
                            <Button type="submit">Update</Button>
                        </div>
                    </div>

                </div >
            </Form >

        </>
    )
}

export default NotificationForm